import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const IssuingProducerPolicy = lazy(
  () => import('@pages/producer/IssuingProducerPolicy'),
);
export const IssuingProducerPolicyRoutes: RouteObject[] = [
  {
    path: '/issuing-producer-policy',
    element: (
      <React.Suspense>
        <IssuingProducerPolicy />
      </React.Suspense>
    ),
  },
];